<template>
    <div class="card mb-6" :style="{ 'min-height': minHeight }">
        <div class="loading-indicator" v-if="isBusy">
            <TDSSpinner :size="24"
                        :border-width="3"
                        color="#FA2922"/>
        </div>
        <div class="card-body fade-in">
            <h2 v-if="title" v-html="title" class="card-title"></h2>
            <p v-if="teaser" v-html="teaser" class="card-teaser mb-4"></p>
            <TDSError :message="error" v-if="error" class="card-error"/>
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import TDSError from "@/components/common/TDSError.vue";
import TDSSpinner from "@/components/common/TDSSpinner.vue";

@Component({
    components: {TDSError, TDSSpinner}
})
export default class DefaultCard extends Vue {
    @Prop({type: Boolean, default: false}) isBusy!: boolean;
    @Prop({type: String}) title!: string;
    @Prop({type: String}) teaser!: string;
    @Prop({type: String}) error!: string;
    @Prop({type: String, default: "0px"}) minHeight!: string;
}
</script>

<style lang="scss" scoped>
.card {
    @include card();

    > .loading-indicator {
        padding: 0;
        display: block;
        float: right;
    }
}
</style>
